import PropTypes from 'prop-types'
import moment from 'moment'
import { DatePicker } from '@material-ui/pickers'
import { Switch, Typography, Grid, Box, TextField } from '@material-ui/core'

import { Controller, useForm } from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import { Label } from 'components'

import helpers from 'helpers'
import * as service from 'service'
import schema from './schema'

const Form = ({
  setIsLoading,
  paymentContract,
  methodPayment,
  refresh,
  setOpenNewOrder,
}) => {
  const snackbar = useSnackbar()

  const typeMethodCard = methodPayment === 'card'

  const { control, errors, handleSubmit, watch } = useForm({
    validationSchema: schema,
    defaultValues: {
      billetExpirationDate: typeMethodCard ? moment().add(1, 'month') : null,
      isNfe: false,
      orderReferenceDate: moment(),
      price: helpers.formatters.currencyInput(paymentContract?.price),
    },
  })

  const onSubmit = async (data) => {
    setIsLoading(true)
    try {
      await service.dponet.paymentOrders.recurrencePaymentOrder({
        paymentOrder: {
          paymentContractId: paymentContract?.id,
          billetExpirationDate: data.billetExpirationDate.format('YYYY-MM-DD'),
          orderReferenceDate: moment(data.orderReferenceDate)
            .endOf('month')
            .format('YYYY-MM-DD'),
          nfeNumber: data.nfeNumber,
          price: data.price
            ? helpers.formatters.currencyOutput(data.price)
            : null,
        },
      })
      snackbar.open({
        message:
          'Sucesso! Uma nova cobrança será enviada ao cliente em até dois minutos.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao gerar nova ordem de pagamento',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      setOpenNewOrder(false)
      refresh()
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="id-new-payment">
      <Grid container spacing={2}>
        <Grid item xs={12} hidden={typeMethodCard}>
          <Controller
            as={
              <DatePicker
                label="Vencimento do boleto"
                color="primary"
                format="DD/MM/yyyy"
                variant="outlined"
                error={!!errors.billetExpirationDate}
                helperText={errors?.billetExpirationDate?.message}
                fullWidth
                disablePast
                onChange={(newValue) => ({ value: newValue })}
              />
            }
            control={control}
            name="billetExpirationDate"
            mode="onChange"
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <DatePicker
                label="Data de referência"
                color="primary"
                format="MM/yyyy"
                variant="dialog"
                views={['year', 'month']}
                error={!!errors.orderReferenceDate}
                helperText={errors?.orderReferenceDate?.message}
                fullWidth
                onChange={(newValue) => ({ value: newValue })}
              />
            }
            control={control}
            name="orderReferenceDate"
            mode="onChange"
          />
        </Grid>
        <Grid item xs={12}>
          <Label title="Essa cobrança já foi faturado no omie?">
            <Controller
              as={
                <Box display="flex" alignItems="center">
                  <Typography variant="body2">Não</Typography>
                  <Switch />
                  <Typography variant="body2">Sim</Typography>
                </Box>
              }
              onChange={([event]) => event.target.checked}
              control={control}
              name="isNfe"
              mode="onChange"
            />
          </Label>
        </Grid>
        {watch('isNfe') === true && (
          <>
            <Grid item xs={12} sm={6}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    label="Digite o número da nota fiscal"
                    type="number"
                    error={!!errors.nfeNumber}
                    helperText={errors?.nfeNumber?.message}
                  />
                }
                control={control}
                name="nfeNumber"
                mode="onChange"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    label="Digite a mensalidade"
                    type="text"
                    error={!!errors.price}
                    helperText={errors?.price?.message}
                  />
                }
                control={control}
                name="price"
                mode="onChange"
                onChange={([event]) => {
                  return helpers.formatters.currencyInput(event.target.value)
                }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </form>
  )
}

Form.propTypes = {
  setIsLoading: PropTypes.func,
  paymentContract: PropTypes.object,
  refresh: PropTypes.func,
  setOpenNewOrder: PropTypes.func,
}

export default Form
